import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/activityInfo', request)
}

export {get}
